import { Box, FormControlLabel, Checkbox, CircularProgress } from '@mui/material';
import { FsButton } from '../button';
import { useEffect, useState } from 'react';
import { DialogWrapper } from '../common/dialogWrapper';

export const SubscriptionChangeDialog = ({
	state = false,
	onClose = () => { },
	name = 'User',
	subscribed = true,
}) => {
	const [value, setValue] = useState(Boolean(subscribed));
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (state) {
			setValue(Boolean(subscribed));
		}
	}, [subscribed, state]);

	const handleClose = (result) => {
		if (loading) return; // Prevent closing while loading
		setTimeout(() => {
			onClose(false, result);
		}, 0);
	};

	const handleSave = () => {
		setLoading(true);
		// Simulate async operation
		setTimeout(() => {
			setLoading(false);
			handleClose(value);
		}, 100);
	};

	return (
		<DialogWrapper
			maxWidth="sm"
			state={state}
			onClose={() => handleClose(null)}
			title={`Email subscription for ${name}`}
			content={
				loading ? (
					<Box className="flex justify-center items-center my-8">
						<CircularProgress />
					</Box>
				) : (
					<Box className="p-4">
						<FormControlLabel
							control={
								<Checkbox
									checked={value}
									onChange={(e) => setValue(e.target.checked)}
									color="primary"
								/>
							}
							label="Subscribed to our email list"
							sx={{
								alignItems: 'center !important',
								'& .MuiFormControlLabel-label': {
									marginLeft: '8px',
								}
							}}
						/>
					</Box>
				)
			}
			actions={
				<Box className="flex items-center gap-2">
					<FsButton
						onClick={handleSave}
						disabled={loading}>
						Save
					</FsButton>
					<FsButton
						variant="outline"
						onClick={() => handleClose(null)}
						disabled={loading}>
						Cancel
					</FsButton>
				</Box>
			}
		/>
	);
};
